import type { CSSProperties } from 'react';
import { minBreakpoints, primarySemiBoldFont, theme } from '@noths/polaris-client-ribbons-base';
import { mediaQuery, pxToRem } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

export interface BackgroundColorCSSProperties extends CSSProperties {
  '--backgroundColor': string;
}

const { responsiveText, spacing } = theme;

export const grid = css`
  grid-row-gap: ${pxToRem(spacing.sm)};
`;

export const gridItem = css`
  grid-column: span 6;
  overflow: hidden;
  border-radius: ${pxToRem(10)};
`;

export const gridItemFourLayout = css`
  ${mediaQuery(
    { min: minBreakpoints.M },
    css`
      grid-column: span 3;
    `,
  )}
`;

export const link = css`
  text-decoration: none;
  color: inherit;

  &:hover {
    box-shadow: 0 ${pxToRem(-2)} ${pxToRem(4)} 0 rgba(0, 0, 0, 0.2);
  }
`;

export const title = css`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0;
  padding: 0 ${spacing.xs}px;
  text-align: center;
  height: ${pxToRem(52)};
  ${primarySemiBoldFont};
  ${responsiveText.BODY.MD};
  background-color: var(--backgroundColor, #f5eee5);

  ${mediaQuery(
    { min: minBreakpoints.L },
    css`
      height: ${pxToRem(56)};
    `,
  )}
`;

export const image = css`
  display: block;
  width: 100%;
  height: auto;
`;
